module.exports = __webpack_public_path__ + "img/CARACTER-SWIFT-3.26792aa9.jpg";